import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/templates/tasks/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
